import { render, staticRenderFns } from "./FamilyMember.vue?vue&type=template&id=3d23efd0&scoped=true&"
import script from "./FamilyMember.vue?vue&type=script&lang=js&"
export * from "./FamilyMember.vue?vue&type=script&lang=js&"
import style0 from "./FamilyMember.vue?vue&type=style&index=0&id=3d23efd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d23efd0",
  null
  
)

export default component.exports